export default theme => ({
    btnAssess: {
        fontWeight: 'bold',
        fontSize: 12,
        textTransform: 'none',
        textDecoration: 'underline',
        color: theme.palette.primary.main
    }
});
